import { IConfig } from '../interfaces/config.interface';

export const stagingConfig: IConfig = {
  apiUrl: 'https://api.center.health/v1/test',
};

export default stagingConfig;
